import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Week, { WeekSkeleton } from 'routes/Products/components/Week';
import { useWeek, useWeekContentData } from '../../contexts/WeekContext';
import { useWLC } from '../../contexts/WLCContext';

const mapStateToProps = state => ({
  user: state.user
});

const CurrentWeek = ({ user, ...props }) => {
  const { wlcProgress, loadingState } = useWLC();
  const { setWeek } = useWeek();

  const { week: fetchedWeek, isLoading: isWeekLoading } = useWeekContentData(
    wlcProgress?.currentWeekSlug,
    'wlc',
    user.authToken,
    { enabled: !loadingState && !!wlcProgress?.currentWeekSlug }
  );

  console.log('WEEK wlcProgress:', wlcProgress);

  useEffect(() => {
    if (fetchedWeek) {
      setWeek(fetchedWeek);
    }
  }, [fetchedWeek, setWeek]);

  return isWeekLoading || loadingState ? (
    <WeekSkeleton />
  ) : (
    <Week key={wlcProgress?.currentWeekSlug} overrideSlug={wlcProgress?.currentWeekSlug} {...props} />
  );
};

export default connect(mapStateToProps)(CurrentWeek);
